module.exports = __webpack_public_path__ + "static/media/show.590317bd.svg";